/* eslint react/prop-types: 0 */
import React from 'react';
import { DragLayer } from 'react-dnd';
import Parse from 'html-react-parser';
import $ from 'jquery';

function getItemStyles(props) {
  const {
    item,
    initialOffset,
    currentOffset,
  } = props;

  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
    width: $(`#s-${item.id} > .card`).width(),
    height: $(`#s-${item.id} > .card`).innerHeight(),
  };
}

const AdminPageSectionDragLayer = (props) => {
  const {
    item,
    itemType,
    isDragging,
  } = props;

  if (!isDragging || itemType === 'pageSectionItem') {
    return null;
  }

  return (
    <div className="section-drag-preview" style={getItemStyles(props)}>
      {Parse($(`#s-${item.id} > .card`).html() || '')}
    </div>
  );
};

export default DragLayer((monitor => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging(),
})))(AdminPageSectionDragLayer);
